export default __webpack_public_path__ + "static/media/clawsofthereaper.199da365.png";